import moment from "moment";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { numDifferentiation, titleCase, TOAST_DURATION, TOAST_ERROR_COLOR, TOAST_POSITION } from "../../../../common/app_constant";
import { ENV, s3_bucket_prod_url, s3_bucket_uat_url, SUB_DIRECTORY } from "../../../../common/constant";
import Blog from "../../../../component/blog";
import { actionDownloadPolicy, actionGetPolicyDashboard, actionGetPolicyInactive, resetDownloadPolicyResponse, resetGetPolicyInactiveResponse, resetGetPolicyResponse } from '../dashboard/store';
import _ from 'lodash';
import { actionPolicyCompanyList, resetPolicyCompanyList } from "../my_profile/store";
import { useRef } from "react";
import Loader from "../../../../component/page_loader";
import CustomerFeedback from "../../../../component/customer_feedback";
import InfromationCard from "../../../../component/information_card";
import Select from 'react-select';
import { Controller, useForm } from "react-hook-form";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

const Policies = () => {
    const dispatch = useDispatch()
    const navigation = useNavigate()
    const { control, formState: { errors }, register } = useForm();
    const { getPolicy, downloadPolicy } = useSelector((state) => ({
        ...state.dashboardStore
    }))

    const { policyCompanyList } = useSelector((state) => ({
        ...state.MyProfileStore
    }))

    const [allPolicy, setAllPolicy] = useState([])
    const [policyActive, setPolicyActive] = useState([])
    const [policyInActive, setPolicyInActive] = useState([])
    const [selectedItem, setSelectedItem] = useState('A')
    const [filterArr, setFilterArr] = useState([])
    const [searchPolicy, setSearchPolicy] = useState(null)
    const [clicked, setClicked] = useState("0");
    const contentEl = useRef();
    const [selectedCompanyId, setSelectedCompanyId] = useState('')
    const [selectedDepartment, setSelectedDepartment] = useState('all')
    const [clientListArr, setClientList] = useState([])
    const [isCustomerFeedback, setIsCustomerFeedback] = useState(false)
    const [isLoader, setIsLoader] = useState(true)

    useEffect(() => {
        dispatch(actionGetPolicyDashboard({ department_name: 'all', client_id: selectedCompanyId }));
        dispatch(actionPolicyCompanyList({ "department_name": "all" }));
    }, [])

    const data = [
        {
            value: 'all',
            text: 'ALL',
            icon: <img src="assets/images/categories/insurance.png" height="15" width="15" />
        },
        {
            value: 'AVIATION',
            text: 'AVIATION',
            icon: <img src="assets/images/categories/aviation_ins.png" height="15" width="15" />
        },
        {
            value: 'ENERGY',
            text: 'ENERGY',
            icon: <img src="assets/images/categories/energy_ins.png" height="15" width="15" />
        },
        {
            value: 'ENGINEERING',
            text: 'ENGINEERING',
            icon: <img src="assets/images/categories/engineering_ins.png" height="15" width="15" />
        },
        {
            value: 'HEALTH',
            text: 'HEALTH',
            icon: <img src="assets/images/categories/health_ins.png" height="15" width="15" />
        },
        {
            value: 'LIABILITY',
            text: 'LIABILITY',
            icon: <img src="assets/images/categories/liability_ins.png" height="15" width="15" />
        },
        {
            value: 'MARINE',
            text: 'MARINE',
            icon: <img src="assets/images/categories/marine_ins.png" height="15" width="15" />
        },
        {
            value: 'MISCELLENOUS',
            text: 'MISCELLENOUS',
            icon: <img src="assets/images/categories/miscellaneous_ins.png" height="15" width="15" />
        },
        {
            value: 'MOTOR',
            text: 'MOTOR',
            icon: <img src="assets/images/categories/motorcycle_ins.png" height="15" width="15" />
        },
        {
            value: 'PROPERTY',
            text: 'PROPERTY',
            icon: <img src="assets/images/categories/property_ins.png" height="15" width="15" />
        },
    ];

    const exportToCSV = (apiData, fileName) => {
        const columnsToInclude = [
            'company_name','department_name','policy_type_name', 'insurer_name','policy_no', 
            'policy_start_date','policy_expiry_date','sum_insured', 'net_premium','tpp_amount',
            'service_tax', 'gross_premium', ,'rm_name', 
        ];
    
        const headers = {
            company_name: 'Company Name', department_name: 'Department Name', policy_type_name: 'Policy Type',
            insurer_name: 'Insurer Name', policy_no: 'Policy Number',  policy_start_date: 'Policy Start Date',
            policy_expiry_date: 'Policy Expiry Date', sum_insured: 'Sum Insured',net_premium: 'Net Premium',
            tpp_amount: 'TPP Amount',  service_tax: 'Service Tax', gross_premium: 'Gross Premium', rm_name: 'RM Name'
        };
    
        const filteredData = apiData.map(row =>
            columnsToInclude.reduce((acc, column) => {
                acc[column] = row[column];
                return acc;
            }, {})
        );
    
        const ws = XLSX.utils.json_to_sheet(filteredData, { header: Object.keys(headers), skipHeader: false });
        XLSX.utils.sheet_add_aoa(ws, [Object.values(headers)], { origin: 'A1' });
    
        const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    
        const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    
        FileSaver.saveAs(data, fileName + '.xlsx');
    };

    useEffect(() => {
        if (policyCompanyList !== null) {
            dispatch(resetPolicyCompanyList())
            if (policyCompanyList.result === true) {
                setClientList(policyCompanyList.response)
            } else {
                // setClientList([])
                switch (policyCompanyList.status) {
                    default:
                }
            }
        }
    }, [policyCompanyList])

    const generateCompanyList = () => {
        var menu = [];
        if (clientListArr != null && clientListArr.length > 0) {
            clientListArr.forEach(function (child, labelIndex) {
                menu.push(
                    <option key={labelIndex} value={child.id}>
                        {child.name}
                    </option>
                );
            });
        }
        return menu;
    };

    useEffect(() => {
        if (selectedDepartment != null) {
            dispatch(actionPolicyCompanyList({ "department_name": selectedDepartment }));
        }
    }, [selectedDepartment])

    useEffect(() => {
        if (selectedItem === 'A') {
            setAllPolicy(policyActive)
            setFilterArr(policyActive)
        }
        if (selectedItem === 'I') {
            setAllPolicy(policyInActive)
            setFilterArr(policyInActive)
        }
    }, [selectedItem, policyActive, policyInActive])

    useEffect(() => {
        if (getPolicy !== null) {
            dispatch(resetGetPolicyResponse())
            if (getPolicy.result === true) {
                setAllPolicy(getPolicy.response)
                var today = moment().format('YYYY-MM-DD')

                var policyActiveArr = []
                var policyInActiveArr = []
                getPolicy.response.map((item, index) => {
                    if (item.policy_expiry_date >= today) {
                        policyActiveArr.push(
                            item
                        )
                    }
                    else {
                        policyInActiveArr.push(
                            item
                        )
                    }
                })
                setPolicyActive(policyActiveArr)
                setPolicyInActive(policyInActiveArr)
                setIsLoader(false)
            } else {
                setIsLoader(false)
                switch (getPolicy.status_code) {
                    case 400:
                        toast.error(getPolicy.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        localStorage.clear()
                        navigation("/login", { replace: true });
                        break;
                    case 401:
                        localStorage.clear()
                        navigation("/login", { replace: true });
                        break;
                    default:
                }
            }
        }
    }, [getPolicy])

    useEffect(() => {
        if (downloadPolicy !== null) {
            dispatch(resetDownloadPolicyResponse())
            if (downloadPolicy.result === true) {
                window.open(downloadPolicy.response.policy_url, '_blank')
            } else {
                switch (downloadPolicy.status_code) {
                    case 400:
                        toast.error(downloadPolicy.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        localStorage.clear()
                        navigation("/login", { replace: true });
                        break;
                    case 401:
                        localStorage.clear()
                        navigation("/login", { replace: true });
                        break;
                    default:
                }
            }
        }
    }, [downloadPolicy])

    const handleToggle = (index) => {
        if (clicked === index) {
            return setClicked("0");
        }
        setClicked(index);
    };

    const renderDocuments = (item) => {
        var arrDoc = []

        item != null && item.length > 0 ?
            item.map((item, index) => {
                arrDoc.push(
                    <div className="col-md-6">
                        <div className="card">
                            <div className="card-body d-flex justify-content-between">
                                <div className="col-10">
                                    <p className="mb-0">{item.actual_uploaded_file_name}</p>
                                    <small>{moment(item.created_at).format('DD/MM/YYYY')}</small>
                                </div>
                                <div className="col-2 text-center">
                                    <i className="fa fa-download cursor-pointer"
                                        onClick={(e) => {
                                            e.preventDefault()
                                            dispatch(actionDownloadPolicy({ dms_id: item.dms_id }))
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })
            :
            arrDoc.push(
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-body">
                            No Documents Uploaded
                        </div>
                    </div>
                </div>
            )

        return arrDoc

    }

    const renderEndorsement = (item) => {
        var arrEndorsement = []

        item != null && item.length > 0 ?
            item.map((item, index) => {
                arrEndorsement.push(
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                <a class=" w-100" data-bs-toggle="collapse" href={`#collapseExample${index}`}
                                    role="button" aria-expanded="false" aria-controls={`collapseExample${index}`}>
                                    <div class="d-flex">
                                        {/* <div class="col-1 text-center my-auto">
                                            <i class="fa fa-download "></i>
                                        </div> */}
                                        <div class="col-10">
                                            <p class="mb-0">{item.policy_type}</p>
                                            <small>Endorsement NO. : {item.endo_no}</small>
                                        </div>
                                    </div>
                                </a>
                                <div class="collapse" id={`collapseExample${index}`}>
                                    <div class="row border-top pt-2 mt-1">
                                        <div class="col-6 mt-2">
                                            <label class="card-label">Policy Type :</label>
                                            <p class="card-value mb-0">{item.policy_type}</p>
                                        </div>
                                        <div class="col-6 mt-2">
                                            <label class="card-label">Insure Company</label>
                                            <p class="card-value mb-0"> {item.insurer_name}</p>
                                        </div>
                                        <div class="col-6 mt-2">
                                            <label class="card-label">Endorsement Executive</label>
                                            <p class="card-value mb-0"> {item.csc_name}</p>
                                        </div>
                                        <div class="col-6 mt-2">
                                            <label class="card-label">RM Name</label>
                                            <p class="card-value mb-0">{item.rm_name}</p>
                                        </div>
                                        <div class="col-6 mt-2">
                                            <label class="card-label">Status</label>
                                            <p class="card-value mb-0">{item.status}</p>
                                        </div>
                                        <div class="col-6 mt-2">
                                            <label class="card-label">Department</label>
                                            <p class="card-value mb-0"> {item.department}</p>
                                        </div>
                                    </div>
                                    <div class="row border-top pt-2 mt-1">
                                        <div class="col-md-4 fw-bold border-end">Net Premium: <span>{numDifferentiation(item.net_premium)}</span></div>
                                        <div class="col-md-4 fw-bold border-end">GST: <span>{numDifferentiation(item.service_tax)}</span></div>
                                        <div class="col-md-4 fw-bold ">Total Premium: <span>{numDifferentiation(item.gross_premium)}</span></div>
                                    </div>
                                    <div class="row border-top pt-2 mt-1">
                                        <div class="col-md-6 fw-bold border-end">Created On: <span>{moment(item.created_at).format('DD/MM/YYYY')}</span></div>
                                        <div class="col-md-6 fw-bold border-end">Modified On:  <span>{moment(item.updated_at).format('DD/MM/YYYY')}</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })
            :
            arrEndorsement.push(
                <></>
            )

        return arrEndorsement

    }
    const renderProgressBar = (item) => {

        var date1 = moment(new Date()).format("YYYY-MM-DD");
        var date2 = moment(item?.policy_expiry_date);
        var days = date2.diff(date1, 'days')

        return (
            <>
                <p class="fw-600 mb-0">{days} Days left</p>
                <div class="progress">
                    <div class="progress-bar" role="progressbar" style={{ width: `${days}%` }} aria-valuenow="135"
                        aria-valuemin="0" aria-valuemax="100"></div>
                </div>
            </>
        )
    }
    const renderPolicy = () => {
        var policyArr = []

        allPolicy != null && allPolicy.length > 0 ?
            allPolicy.map((item, index) => {
                policyArr.push(
                    <div className="accordion">
                        <div className="col-12 mt-3 position-relative">
                            <div className="card border-0 policy-card">
                                <div className="card-header d-flex" onClick={() => {
                                    handleToggle(index)
                                }}>
                                    <div>
                                        <img
                                            src={`${ENV === 'development' ? s3_bucket_uat_url : s3_bucket_prod_url}projects/pinc_network/resources/insurance_products_icons/ic_default.png`}
                                            className="card-icon ms-auto"
                                            alt=""
                                        />
                                        <span className="ms-auto fw-600 card-title">{item.policy_type_name}</span>
                                    </div>
                                    {/* <span class="badge rounded-pill bg-primary ms-auto lh-base">View Quote</span> */}
                                </div>
                                <div className="card-body pointer">
                                    <div className="row">
                                        <div class="col-6">
                                            <label class="card-label mb-2"> <b>{titleCase(item.company_name)}</b></label>
                                        </div>
                                        <div class="col-6 d-flex">
                                            <label className="card-label my-auto">Insurer Name:
                                                <span className="card-value mb-0 my-auto"> {item?.insurer_name ? item?.insurer_name : "-"}</span></label>
                                        </div>
                                        <div className="col-12 col-md-2">
                                            <img
                                                src={item.insurer_company_logo}
                                                className="w-75"
                                                alt=""
                                            />
                                        </div>
                                        <div className="col-12 col-md-8">
                                            <div className="row">
                                                <div className="col-6 mt-2 mt-md-0">
                                                    <label className="card-label">Policy No.:</label>
                                                    <p className="card-value mb-0"> {item.policy_no}</p>
                                                </div>
                                                <div className="col-6 mt-2 mt-md-0">
                                                    <label class="card-label">Premium:</label>
                                                    <p className="card-value mb-0">₹ {numDifferentiation(item.net_premium)} </p>
                                                </div>
                                                <div className="col-6 mt-2 mt-md-0">
                                                    <label className="card-label">Start Date:</label>
                                                    <p className="card-value mb-0">{moment(item.policy_start_date).format('DD/MM/YYYY')}</p>
                                                </div>
                                                <div className="col-6 mt-2 mt-md-0">
                                                    <label className="card-label">End Date:</label>
                                                    <p className="card-value mb-0">{moment(item.policy_expiry_date).format('DD/MM/YYYY')}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-2 text-start">
                                            <label className="card-label text-primary fw-600">
                                                Renewal Status:
                                            </label>
                                            {
                                                selectedItem === 'A' ?
                                                    renderProgressBar(item)
                                                    :
                                                    <p className="fw-600 mb-0 badge bg-danger rounded">Expired</p>

                                            }
                                        </div>

                                        <div className="col-12"
                                            ref={contentEl}
                                            hidden={clicked === index ? false : true}>
                                            <div className="row mt-3 bg-light py-3 rounded fs-7 ">
                                                <div className="col-md-6">
                                                    {/* <p className="mb-0">
                                                        <b>{item.insurer_name}</b>
                                                    </p> */}
                                                    {/* <p>
                                                        <span className="text-primary">Branch:</span>
                                                        {item.insurer_branches}
                                                    </p> */}
                                                    <p className="text-dark my-auto">
                                                        Contact Person:{" "}
                                                        <b className="text-primary">{item.rm_name}</b>
                                                    </p>
                                                </div>
                                                <div className="col-md-6">
                                                    <ul className="list-group">
                                                        <li className="list-group-item d-flex justify-content-between">
                                                            <span className="text-dark my-auto">
                                                                Status: <b className="text-primary">{_.capitalize(item.policy_status)}</b>
                                                            </span>
                                                            <button className="btn btn-sm btn-primary fs-7"
                                                                onClick={() => {
                                                                    navigation('/claim/intimate-claim', { state: { data: item } })
                                                                }}
                                                            >
                                                                Intimate Claim
                                                            </button>
                                                        </li>
                                                        <li className="list-group-item d-flex justify-content-between bg-light">
                                                            <span className="fw-bold">Sum Insured</span>{" "}
                                                            <span className="fw-bold">
                                                                <i className="fa fa-inr" /> {numDifferentiation(item.sum_insured)}
                                                            </span>
                                                        </li>
                                                        <li className="list-group-item d-flex justify-content-between">
                                                            <span>Net Premium</span>{" "}
                                                            <span>
                                                                <i className="fa fa-inr" />{numDifferentiation(item.net_premium)}
                                                            </span>
                                                        </li>
                                                        <li className="list-group-item d-flex justify-content-between">
                                                            <span>GST</span>{" "}
                                                            <span>
                                                                <i className="fa fa-inr" /> {numDifferentiation(item.service_tax)}
                                                            </span>
                                                        </li>
                                                        <li className="list-group-item d-flex justify-content-between">
                                                            <span>
                                                                <b>Gross Premium</b>
                                                            </span>
                                                            <b>
                                                                {" "}
                                                                <span>
                                                                    <i className="fa fa-inr" /> {numDifferentiation(item.gross_premium)}
                                                                </span>
                                                            </b>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="col-12 mt-3 mt-md-0">
                                                    <h6>Documents({item.documents.length})</h6>
                                                </div>
                                                {renderDocuments(item.documents)}
                                                <div class="col-12 mt-3">
                                                    <h6>Endorsement</h6>
                                                </div>
                                                {renderEndorsement(item.endorsements)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <img alt="ribbon" className="ribbon" src={`${SUB_DIRECTORY}/assets/images/ribbon.png`} />
                        </div>
                    </div>

                )
            })
            :
            <></>
        return policyArr
    }

    return (
        <>
            <div className="row py-5">
                <div className="col-12 col-md-8 d-flex justify-content-between">
                    <div>
                        <nav
                            aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><a onClick={() => {
                                    navigation('/dashboard')
                                }}>Dashboard</a></li>
                                <li class="breadcrumb-item active" aria-current="page">Policies</li>
                            </ol>
                        </nav>
                    </div>
                    <div>
                        <button class="btn btn-success btn-sm"
                            onClick={() => {
                                exportToCSV(allPolicy, 'Policy data')
                            }}
                        >
                            <i class="fa fa-download" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
                <div className="col-12 col-md-8">
                    {
                        isLoader === true ?
                            <Loader />
                            :
                            <>
                                <div className="row">
                                    <div class="col-md-3">
                                        <div class="card-body">
                                            <Controller
                                                control={control}
                                                name="category"
                                                render={({ field: { value, onChange } }) => (
                                                    <Select
                                                        placeholder="Select Option"
                                                        defaultValue={data[0]}
                                                        options={data}
                                                        isSearchable={true}
                                                        onChange={(e) => {
                                                            dispatch(actionGetPolicyDashboard({ department_name: e.value, client_id: selectedCompanyId }))
                                                            const selectedDepartment = e?.value;
                                                            setSelectedDepartment(selectedDepartment);
                                                        }}
                                                        getOptionLabel={e => (
                                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                {e.icon}
                                                                <span style={{ marginLeft: 5 }}>{e.text}</span>
                                                            </div>
                                                        )}
                                                    />
                                                )}
                                            />
                                        </div>
                                    </div>
                                    <div class="card profile-section col-md-7">
                                        <div class="card-body">
                                            <form>
                                                <div class="form-group has-search">
                                                    <span class="fa fa-search form-control-feedback"></span>
                                                    <input
                                                        type="text"
                                                        name="search"
                                                        className="form-control"
                                                        placeholder={'Search Policy'}
                                                        value={searchPolicy}
                                                        onChange={(event) => {
                                                            const inputValue = event?.target?.value.toLowerCase();
                                                            setSearchPolicy(event?.target?.value);
                                                            if (inputValue?.length > 0) {
                                                                const filteredArr = filterArr.filter(
                                                                    (item) =>
                                                                        (item?.policy_no && item?.policy_no?.toLowerCase().includes(inputValue)) ||
                                                                        (item?.company_name && item?.company_name?.toLowerCase().includes(inputValue)) ||
                                                                        (item?.insurer_name && item?.insurer_name?.toLowerCase().includes(inputValue))
                                                                );
                                                                setAllPolicy(filteredArr);
                                                            } else {
                                                                setSearchPolicy('');
                                                                if (selectedItem === 'A') {
                                                                    setAllPolicy(policyActive || []);
                                                                } else if (selectedItem === 'I') {
                                                                    setAllPolicy(policyInActive || []);
                                                                }
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                    <div class="col-md-2 my-auto mt-2 mt-md-auto text-center">
                                        <button class="btn btn-primary btn-sm"
                                            onClick={() => {
                                                navigation('/policy-wallet/add-policy-wallet')
                                            }}
                                        >
                                            Add Policy</button>
                                    </div>
                                </div>
                            </>
                    }

                    <div>
                        <div className="mt-4 row justify-content-between tab-menu">
                            <div className="col-12 col-md-6">
                                <button
                                    className={`btn btn-light btn-sm ${selectedItem === "A" ? 'active' : ''}`}
                                    onClick={() => {
                                        setClicked(null);
                                        setSelectedItem("A")
                                    }}
                                >
                                    Active({`${policyActive?.length}`})
                                </button>
                                <button
                                    className={`btn btn-light btn-sm ${selectedItem === "I" ? 'active' : ''}`}
                                    style={{
                                        marginLeft: 14,
                                    }}
                                    onClick={() => {
                                        setClicked(null);
                                        setSelectedItem("I")
                                    }}
                                >
                                    Expired ({`${policyInActive?.length}`})
                                </button>
                            </div>
                            <div class="col-md-4 my-auto text-center float-end">
                                <select
                                    id="client_id"
                                    className="form-control form-select"
                                    {...register(
                                        "client_id",
                                    )}
                                    onChange={(event) => {
                                        dispatch(actionGetPolicyDashboard({ department_name: selectedDepartment, client_id: Number(event?.target?.value) }));
                                        const selectedId = Number(event?.target?.value);
                                        setSelectedCompanyId(selectedId);
                                    }}
                                    value={selectedCompanyId}
                                >
                                    <option value="">Company Name</option>
                                    {generateCompanyList()}
                                </select>
                            </div>
                        </div>
                    </div>
                    {
                        allPolicy != null && allPolicy.length > 0 ?
                            <div className="row">
                                {renderPolicy()}
                            </div>
                            :
                            <div className="d-flex justify-content-center align-items-center mt-5">
                                <h5>No Policies To Display</h5>
                            </div>

                    }
                </div>
                <div className="col-12 col-md-4">
                    <InfromationCard isMarginTop={false} />
                    <Blog />
                </div>
            </div >

            <CustomerFeedback
                isCustomerFeedback={isCustomerFeedback}
                feedbackClose={() => {
                    setIsCustomerFeedback(false)
                }}
            />
        </>

    )

}

export default Policies;